import { apiManager } from './apiManager';

export const downloadZoneApi = {
  getContent: async (id) => {
    return await apiManager.get(`/api/downloads/center/${id}`);
  },
  getVideosById: async (id) =>
    await this.getRequest(`/api/vimeo/download-links/${id}`),
};
